import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireAnyPermission, requireModule } from '../../../app/guards'

export const Route = createFileRoute('/_app/workflows')({
  staticData: { crumb: 'workflows' },
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'workflows')
    requireAnyPermission(context.session, 'workflows.read', 'workflows.runs', 'workflows.delegations')
  },
  component: Outlet,
})
